import { WorkspaceSwitcher } from "../shared/WorkspaceSwitcher";
import type { RootView } from "../shared/productTypes";

export default function CustomerPortalApp({ onNavigateRoot }: { onNavigateRoot: (view: RootView) => void }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
      <div
        style={{
          padding: "var(--spacing-m) var(--spacing-l)",
          borderBottom: "1px solid var(--color-border-primary)",
          background: "var(--color-bg-accent)",
        }}
      >
        <WorkspaceSwitcher
          activeProductId="customer-portal"
          onSelectProduct={onNavigateRoot}
          onOpenDashboard={() => onNavigateRoot("home")}
        />
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "var(--spacing-s)",
          background: "var(--color-bg-primary)",
        }}
      >
        <span style={{ fontSize: 40 }}>🚧</span>
        <p style={{ fontSize: 16, fontWeight: 700, color: "var(--color-content-primary)", margin: 0 }}>
          Makula Customer Portal
        </p>
        <p style={{ fontSize: 14, fontWeight: 500, color: "var(--color-content-secondary)", margin: 0 }}>
          This product is coming soon.
        </p>
      </div>
    </div>
  );
}
